module.exports = __webpack_public_path__ + "img/ep2-10.31f9b99a.png";